import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path
        d='M11.5 7H7.22222C6.89807 7 6.58719 7.12877 6.35798 7.35798C6.12877 7.58719 6 7.89807 6 8.22222V16.7778C6 17.1019 6.12877 17.4128 6.35798 17.642C6.58719 17.8712 6.89807 18 7.22222 18H15.7778C16.1019 18 16.4128 17.8712 16.642 17.642C16.8712 17.4128 17 17.1019 17 16.7778V12.5'
        stroke={fillColor}
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.692 6.39599C15.9456 6.14244 16.2894 6 16.648 6C17.0066 6 17.3505 6.14244 17.604 6.39599C17.8576 6.64954 18 6.99342 18 7.35199C18 7.71056 17.8576 8.05444 17.604 8.30799L11.5493 14.3627L9 15L9.63733 12.4507L15.692 6.39599Z'
        stroke={fillColor}
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

export default React.memo(Icon);
